import { SkeletonMainLayout } from 'src/modules/common/skeletons/SkeletonMainLayout/SkeletonMainLayout.tsx';
import { PropsWithChildren, Suspense, useContext, useMemo } from 'react';
import { ConfigContext } from 'src/configContext.ts';
import { useScreenSize } from 'src/modules/common/hooks/useScreenSize.ts';
import { RuntimeContext } from 'src/runtimeContext.ts';
import { MOBILE_WIDTH } from 'src/modules/common/constants.ts';
import { getModalRoot } from 'src/utils/getModalRoot.ts';

export const RuntimeContextProvider = ({ children }: PropsWithChildren) => {
    const { userSettings, rootElement } = useContext(ConfigContext);

    const collator = useMemo(() => {
        const language = userSettings.currentLocale.substring(0, 2);

        return new Intl.Collator(language);
    }, [userSettings.currentLocale]);

    const { width } = useScreenSize();
    const value: RuntimeContext = useMemo(() => ({
        isMobile: width <= MOBILE_WIDTH,
        collator,
        ...getModalRoot(rootElement),
    }), [width, collator, rootElement]);
    return (
        <RuntimeContext.Provider value={value}>
            <Suspense fallback={<SkeletonMainLayout/>}>{children}</Suspense>
        </RuntimeContext.Provider>
    );
};
